export { default } from './PageSkeleton';
